import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "iemed_brand_v1";
const listeners = new Set();
let state = (() => { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; } })();
let loading = null;

const abs = (u) => (u ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

const applyFavicons = (b) => {
  if (!b) return;
  [["icon", b.favicon_ico, null], ["icon", b.favicon_png, "32x32"], ["apple-touch-icon", b.apple_touch_icon, null]].forEach(([rel, href, sizes]) => {
    const sel = `link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ":not([sizes])"}`;
    let el = document.head.querySelector(sel);
    if (!el) { el = document.createElement("link"); el.rel = rel; if (sizes) el.sizes = sizes; document.head.appendChild(el); }
    el.href = abs(href);
  });
};

const set = (b) => {
  state = b;
  try { localStorage.setItem(KEY, JSON.stringify(b)); } catch { /* storage unavailable */ }
  applyFavicons(b);
  listeners.forEach((fn) => fn(b));
};

export const refreshBrand = () => {
  loading = api.get("/public/brand").then((r) => set(r.data)).catch(() => {});
  return loading;
};

export const brandUrl = abs;

export const useBrand = () => {
  const [b, setB] = useState(state);
  useEffect(() => {
    listeners.add(setB);
    if (!loading) refreshBrand();
    return () => listeners.delete(setB);
  }, []);
  return b;
};
